import type { Tag } from '../lib/types';
import { LockIcon, UsersIcon } from './icons';
import { cx } from './ui';

/**
 * Whose a tag is, said the same way everywhere a tag is shown: a team tag
 * with the people icon, a personal one with the lock, because the one is
 * seen by everyone on the team and the other by nobody but you.
 */

export const SCOPE_TITLE: Record<Tag['scope'], string> = {
  team: 'Team tag: everyone on your team sees it',
  personal: 'Personal tag: only you see it',
};

export function TagScopeIcon({ scope, size = 11, className }: { scope: Tag['scope']; size?: number; className?: string }) {
  const Icon = scope === 'team' ? UsersIcon : LockIcon;
  return (
    <span title={SCOPE_TITLE[scope]} className={cx('inline-flex shrink-0', className)}>
      <Icon size={size} aria-hidden="true" />
      <span className="sr-only">{scope === 'team' ? 'Team tag' : 'Personal tag'}</span>
    </span>
  );
}

/** The icon and the word, for lists where there is room for both. */
export function TagScopeLabel({ scope, className }: { scope: Tag['scope']; className?: string }) {
  const Icon = scope === 'team' ? UsersIcon : LockIcon;
  return (
    <span title={SCOPE_TITLE[scope]} className={cx('inline-flex shrink-0 items-center gap-1', className)}>
      <Icon size={11} aria-hidden="true" />
      {scope === 'team' ? 'Team' : 'Only you'}
    </span>
  );
}
